import { MessageBubble } from './MessageBubble'
import { ThreadBoundary } from './ThreadBoundary'
import { ThreadAnalysis } from '@/features/analysis/ThreadAnalysis'
import type { ThreadWithMessages } from '@/types'

interface ChatTimelineProps {
  threads: ThreadWithMessages[]
}

export function ChatTimeline({ threads }: ChatTimelineProps) {
  if (threads.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center text-muted-foreground">
        대화 스레드가 없습니다
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {threads.map((thread) => (
        <div
          key={thread.thread_id}
          className="rounded-xl border-2 border-border bg-card p-4 shadow-sm"
        >
          <ThreadBoundary
            threadId={thread.thread_id}
            startedAt={thread.thread_started_at}
            endedAt={thread.thread_ended_at}
            messageCount={thread.message_count}
            isActive={thread.is_active}
          />

          <div className="mt-4 space-y-2 border-l-2 border-primary/30 pl-4">
            {thread.messages.map((message) => (
              <MessageBubble
                key={message.id}
                role={message.role}
                content={message.content}
                timestamp={message.timestamp}
              />
            ))}
          </div>

          <div className="mt-4">
            <ThreadAnalysis threadId={thread.thread_id} />
          </div>
        </div>
      ))}
    </div>
  )
}
